import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;

import { computed, observable, makeObservable, runInAction } from "mobx";
import { findMenuItemAvailibilityFromDayPartInfo } from "../../utils/common";
import BrandRules from "../../utils/BrandRules";
import moment from "moment";
var OrderHistoryModel = (_class = /*#__PURE__*/function () {
  function OrderHistoryModel(platformUtil) {
    _classCallCheck(this, OrderHistoryModel);

    _initializerDefineProperty(this, "_orderHistory", _descriptor, this);

    _initializerDefineProperty(this, "_dayPartInfo", _descriptor2, this);

    _initializerDefineProperty(this, "_currentPickupTime", _descriptor3, this);

    _initializerDefineProperty(this, "_unavailableItems", _descriptor4, this);

    _initializerDefineProperty(this, "_currentOrderDetails", _descriptor5, this);

    _initializerDefineProperty(this, "_menuDetail", _descriptor6, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor7, this);

    _initializerDefineProperty(this, "_selectedOrderId", _descriptor8, this);

    _initializerDefineProperty(this, "_recentOrdersFromLocalStorage", _descriptor9, this);

    makeObservable(this);
  }

  _createClass(OrderHistoryModel, [{
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this = this;

      runInAction(function () {
        _this._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setOrderHistoryData",
    value: function setOrderHistoryData(_orderHistory) {
      var _this2 = this;

      runInAction(function () {
        _this2._orderHistory = _orderHistory;
      });
    }
  }, {
    key: "setMenuDetailData",
    value: function setMenuDetailData(_menuDetail) {
      var _this3 = this;

      runInAction(function () {
        _this3._menuDetail = _menuDetail;
      });
    }
  }, {
    key: "setCurrentOrderDetails",
    value: function setCurrentOrderDetails(idDetails) {
      var _this4 = this;

      runInAction(function () {
        _this4._currentOrderDetails = idDetails;
      });
    }
  }, {
    key: "setUnavailableItemsData",
    value: function setUnavailableItemsData(_unavailableItems) {
      var _this5 = this;

      runInAction(function () {
        _this5._unavailableItems = _unavailableItems;
      });
    }
  }, {
    key: "setPickupTimeData",
    value: function setPickupTimeData(data) {
      var _this6 = this;

      runInAction(function () {
        _this6._currentPickupTime = data;
      });
    }
  }, {
    key: "setDayPartInfoData",
    value: function setDayPartInfoData(_dayPartInfo) {
      var _this7 = this;

      runInAction(function () {
        _this7._dayPartInfo = _dayPartInfo;
      });
    }
  }, {
    key: "checkMenuItemAvailibility",
    value: function checkMenuItemAvailibility(id) {
      return this.unavailableProducts["".concat(id)] ? {
        isUnavailable: true,
        unAvailableMessage: ""
      } : findMenuItemAvailibilityFromDayPartInfo(id, this._dayPartInfo, this._currentPickupTime);
    }
  }, {
    key: "checkSkuAvailibility",
    value: function checkSkuAvailibility(id) {
      return !!this.unavailableModifiers["".concat(id)];
    }
  }, {
    key: "_decodeOrderHistory",
    value: function _decodeOrderHistory(orderHistory) {
      var _this8 = this;

      return orderHistory === null || orderHistory === void 0 ? void 0 : orderHistory.map(function (orderItem) {
        var _orderItem$order, _orderItem$submittedD;

        var items = _this8._decodeOrderHistoryItems(orderItem === null || orderItem === void 0 ? void 0 : (_orderItem$order = orderItem.order) === null || _orderItem$order === void 0 ? void 0 : _orderItem$order.commerceItems);

        return {
          id: orderItem === null || orderItem === void 0 ? void 0 : orderItem.id,
          date: moment(orderItem === null || orderItem === void 0 ? void 0 : (_orderItem$submittedD = orderItem.submittedDate) === null || _orderItem$submittedD === void 0 ? void 0 : _orderItem$submittedD.time).toDate(),
          isOrderUnAvailable: _this8._isOrderUnAvailable(items),
          items: items,
          orderType: orderItem === null || orderItem === void 0 ? void 0 : orderItem.orderType
        };
      });
    }
  }, {
    key: "_isOrderUnAvailable",
    value: function _isOrderUnAvailable(orderItems) {
      var totalOrderItems = orderItems === null || orderItems === void 0 ? void 0 : orderItems.length;
      var unAvailableItemCount = 0;
      orderItems === null || orderItems === void 0 ? void 0 : orderItems.map(function (item) {
        if (!item.isAvailable) {
          unAvailableItemCount += 1;
        }
      });
      return totalOrderItems === unAvailableItemCount;
    }
  }, {
    key: "_decodeOrderHistoryItems",
    value: function _decodeOrderHistoryItems(orderItems) {
      var _this9 = this;

      var menuListAvailableItemIds = this.getMenuListAvailableItemIds;
      return orderItems === null || orderItems === void 0 ? void 0 : orderItems.map(function (item) {
        var _item$productRef, _item$productRef2, _item$priceInfo;

        var _this9$checkMenuItemA = _this9.checkMenuItemAvailibility(item === null || item === void 0 ? void 0 : item.productId),
            isUnavailable = _this9$checkMenuItemA.isUnavailable;

        return {
          id: item.id,
          name: item === null || item === void 0 ? void 0 : item.displayName,
          customizations: _this9._decodeOrderHistorySubItems(item === null || item === void 0 ? void 0 : item.subItem),
          isAvailable: !_this9.checkMenuItemAvailibility(item === null || item === void 0 ? void 0 : item.productId).isUnavailable && !_this9._isModifierAvailable(item === null || item === void 0 ? void 0 : item.subItem) && menuListAvailableItemIds.includes(item.productId),
          isDiscontinued: false,
          // not present in response
          calorieCount: (item === null || item === void 0 ? void 0 : item.calories) > 0 ? item === null || item === void 0 ? void 0 : item.calories : item === null || item === void 0 ? void 0 : item.nutritionalFDAMessage,
          imageUrl: (item === null || item === void 0 ? void 0 : (_item$productRef = item.productRef) === null || _item$productRef === void 0 ? void 0 : _item$productRef.largeImage) || (item === null || item === void 0 ? void 0 : (_item$productRef2 = item.productRef) === null || _item$productRef2 === void 0 ? void 0 : _item$productRef2.largeImageUrl),
          price: item === null || item === void 0 ? void 0 : (_item$priceInfo = item.priceInfo) === null || _item$priceInfo === void 0 ? void 0 : _item$priceInfo.amount
        };
      });
    }
  }, {
    key: "_isModifierAvailable",
    value: function _isModifierAvailable(subItems) {
      var _this10 = this;

      var modifierUvailibility = subItems.map(function (item) {
        return _this10.checkSkuAvailibility(item.catalogRefId);
      });
      return modifierUvailibility.includes(true);
    }
  }, {
    key: "_decodeOrderHistorySubItems",
    value: function _decodeOrderHistorySubItems(subItems) {
      var _this11 = this;

      return subItems === null || subItems === void 0 ? void 0 : subItems.map(function (subItem) {
        var _this11$_appAttribute;

        var newOptionName = new BrandRules((_this11$_appAttribute = _this11._appAttributes) === null || _this11$_appAttribute === void 0 ? void 0 : _this11$_appAttribute.currentConceptCode).cartCustomizationName(subItem === null || subItem === void 0 ? void 0 : subItem.skuDisplayName, subItem === null || subItem === void 0 ? void 0 : subItem.optionType);
        return "".concat(subItem === null || subItem === void 0 ? void 0 : subItem.displayName, " - ").concat(newOptionName);
      });
    }
  }, {
    key: "getPreviousOrderDetail",
    value: function getPreviousOrderDetail(orderId) {
      if (this._orderHistory && this._orderHistory.length) {
        var filteredOrders = this._orderHistory.filter(function (currentOrder) {
          return currentOrder.id === orderId;
        });

        if (filteredOrders.length) {
          return filteredOrders[0];
        } else {
          return null;
        }
      } else {
        return null;
      }
    }
  }, {
    key: "getPaymentDetails",
    value: function getPaymentDetails(orderId) {
      var _order$order, _order$order$paymentG;

      var details = [];
      var order = this.getPreviousOrderDetail(orderId);
      order === null || order === void 0 ? void 0 : (_order$order = order.order) === null || _order$order === void 0 ? void 0 : (_order$order$paymentG = _order$order.paymentGroup) === null || _order$order$paymentG === void 0 ? void 0 : _order$order$paymentG.forEach(function (amount) {
        var _ref;

        details.push({
          creditCardType: amount === null || amount === void 0 ? void 0 : amount.creditCardType,
          amount: (_ref = (amount === null || amount === void 0 ? void 0 : amount.amount) + (amount === null || amount === void 0 ? void 0 : amount.tipAmount) + (amount === null || amount === void 0 ? void 0 : amount.paygrpTipAmount)) !== null && _ref !== void 0 ? _ref : 0,
          paygrpTipAmount: amount === null || amount === void 0 ? void 0 : amount.paygrpTipAmount,
          tipAmount: amount === null || amount === void 0 ? void 0 : amount.tipAmount,
          paymentMethod: amount === null || amount === void 0 ? void 0 : amount.paymentMethod,
          paymentCardToken: amount === null || amount === void 0 ? void 0 : amount.paymentCardToken,
          giftCardNumber: amount === null || amount === void 0 ? void 0 : amount.giftCardNumber,
          giftCardType: amount === null || amount === void 0 ? void 0 : amount.giftCardType,
          walletType: amount === null || amount === void 0 ? void 0 : amount.walletType
        });
      });
      return details;
    }
  }, {
    key: "getItemName",
    value: function getItemName(orderId, itemId) {
      var _currentOrder$;

      var currentOrder = this._orderHistory.filter(function (currentOrder) {
        return currentOrder.id === orderId;
      });

      var orderDeatils = (_currentOrder$ = currentOrder[0]) === null || _currentOrder$ === void 0 ? void 0 : _currentOrder$.order;
      var currentOrderItem = orderDeatils === null || orderDeatils === void 0 ? void 0 : orderDeatils.commerceItems.filter(function (item) {
        return item.productId === itemId;
      });
      var currentOrderItemDetails = currentOrderItem[0];
      return currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.displayName;
    }
  }, {
    key: "getRequiredAddToCartData",
    value: function getRequiredAddToCartData(orderId, itemId) {
      var _currentOrder$2;

      var currentOrder = this._orderHistory.filter(function (currentOrder) {
        return currentOrder.id === orderId;
      });

      var orderDeatils = (_currentOrder$2 = currentOrder[0]) === null || _currentOrder$2 === void 0 ? void 0 : _currentOrder$2.order;
      var currentOrderItem = orderDeatils === null || orderDeatils === void 0 ? void 0 : orderDeatils.commerceItems.filter(function (item) {
        return item.id === itemId;
      });
      var currentOrderItemDetails = currentOrderItem[0];
      return {
        restaurantId: orderDeatils === null || orderDeatils === void 0 ? void 0 : orderDeatils.restaurantId,
        productId: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.productId,
        productName: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.displayName,
        productSku: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.selectedSkuItem,
        productPrice: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.priceInfo,
        catalogRefIds: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.catalogRefId,
        selectedIds: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.subItem.map(function (item) {
          return item.selectedId;
        }),
        quantity: currentOrderItemDetails === null || currentOrderItemDetails === void 0 ? void 0 : currentOrderItemDetails.quantity,
        configQuantity: 1,
        fromPage: "reorder",
        smartRecommended: false,
        itemInstructions: currentOrderItemDetails.itemInstructions,
        guestName: ""
      };
    }
  }, {
    key: "getRequiredAddAllToCartData",
    value: function getRequiredAddAllToCartData(orderId) {
      var _currentOrder$3,
          _this12 = this;

      var menuListAvailableItemIds = this.getMenuListAvailableItemIds;

      var currentOrder = this._orderHistory.filter(function (currentOrder) {
        return currentOrder.id === orderId;
      });

      var orderDeatils = (_currentOrder$3 = currentOrder[0]) === null || _currentOrder$3 === void 0 ? void 0 : _currentOrder$3.order;
      return orderDeatils === null || orderDeatils === void 0 ? void 0 : orderDeatils.commerceItems.map(function (item) {
        var _this12$checkMenuItem = _this12.checkMenuItemAvailibility(item === null || item === void 0 ? void 0 : item.productId),
            isUnavailable = _this12$checkMenuItem.isUnavailable;

        return {
          restaurantId: orderDeatils === null || orderDeatils === void 0 ? void 0 : orderDeatils.restaurantId,
          productId: item === null || item === void 0 ? void 0 : item.productId,
          catalogRefIds: item === null || item === void 0 ? void 0 : item.catalogRefId,
          selectedIds: item === null || item === void 0 ? void 0 : item.subItem.map(function (item) {
            return item.selectedId;
          }),
          quantity: item === null || item === void 0 ? void 0 : item.quantity,
          configQuantity: 1,
          fromPage: "reorder",
          smartRecommended: false,
          itemInstructions: item.itemInstructions,
          guestName: "",
          isUnavailable: isUnavailable || _this12._isModifierAvailable(item === null || item === void 0 ? void 0 : item.subItem) || !menuListAvailableItemIds.includes(item === null || item === void 0 ? void 0 : item.productId)
        };
      });
    }
  }, {
    key: "getMenuListAvailableItemIds",
    get: function get() {
      var _this$_menuDetail, _this$_menuDetail$sub;

      var ids = [];
      (_this$_menuDetail = this._menuDetail) === null || _this$_menuDetail === void 0 ? void 0 : (_this$_menuDetail$sub = _this$_menuDetail.subCategories) === null || _this$_menuDetail$sub === void 0 ? void 0 : _this$_menuDetail$sub.forEach(function (cat) {
        var categories = cat;

        if (categories !== null && categories !== void 0 && categories.menucategories) {
          var subCategories = categories === null || categories === void 0 ? void 0 : categories.menucategories;
          subCategories === null || subCategories === void 0 ? void 0 : subCategories.forEach(function (subCat) {
            var subCatgory = subCat;

            if (subCatgory !== null && subCatgory !== void 0 && subCatgory.menu) {
              var _subCatgory$menu;

              subCatgory === null || subCatgory === void 0 ? void 0 : (_subCatgory$menu = subCatgory.menu) === null || _subCatgory$menu === void 0 ? void 0 : _subCatgory$menu.forEach(function (item) {
                return ids.push(item === null || item === void 0 ? void 0 : item.id);
              });
            }

            if (subCatgory !== null && subCatgory !== void 0 && subCatgory.menucategories) {
              var subSubCategory = subCatgory === null || subCatgory === void 0 ? void 0 : subCatgory.menucategories;
              subSubCategory === null || subSubCategory === void 0 ? void 0 : subSubCategory.forEach(function (subSubCat) {
                var _subSubCat$menu;

                subSubCat === null || subSubCat === void 0 ? void 0 : (_subSubCat$menu = subSubCat.menu) === null || _subSubCat$menu === void 0 ? void 0 : _subSubCat$menu.forEach(function (item) {
                  return ids.push(item === null || item === void 0 ? void 0 : item.id);
                });
              });
            }
          });
        }

        if (categories !== null && categories !== void 0 && categories.menu) {
          var _categories$menu;

          categories === null || categories === void 0 ? void 0 : (_categories$menu = categories.menu) === null || _categories$menu === void 0 ? void 0 : _categories$menu.forEach(function (item) {
            return ids.push(item === null || item === void 0 ? void 0 : item.id);
          });
        }
      });
      return ids;
    }
  }, {
    key: "currentOrderDetails",
    get: function get() {
      return this._currentOrderDetails;
    }
  }, {
    key: "unavailableModifiers",
    get: function get() {
      var _this$_unavailableIte;

      return ((_this$_unavailableIte = this._unavailableItems) === null || _this$_unavailableIte === void 0 ? void 0 : _this$_unavailableIte.modifiersMap) || {};
    }
  }, {
    key: "unavailableProducts",
    get: function get() {
      var _this$_unavailableIte2;

      return ((_this$_unavailableIte2 = this._unavailableItems) === null || _this$_unavailableIte2 === void 0 ? void 0 : _this$_unavailableIte2.productsMap) || {};
    }
  }, {
    key: "orderHistory",
    get: function get() {
      return this._orderHistory;
    }
  }, {
    key: "selectedOrderId",
    get: function get() {
      return this._selectedOrderId;
    },
    set: function set(_selectedOrderId) {
      var _this13 = this;

      runInAction(function () {
        _this13._selectedOrderId = _selectedOrderId;
      });
    }
  }, {
    key: "recentOrder",
    get: function get() {
      return this._orderHistory && this._decodeOrderHistory(this._orderHistory)[0];
    }
  }, {
    key: "recentNonCateringDeliveryOrder",
    get: function get() {
      var order = null;

      if (this._orderHistory) {
        order = this._decodeOrderHistory(this._orderHistory)[0];
        if (order && order.orderType !== 2) return order;
      }

      return order;
    }
  }, {
    key: "previousOrders",
    get: function get() {
      return this._orderHistory && this._decodeOrderHistory(this._orderHistory).slice(1);
    }
  }, {
    key: "previousNonCateringDeliveryOrders",
    get: function get() {
      if (this._orderHistory) {
        var _this$_decodeOrderHis;

        var allPreviousOrders = (_this$_decodeOrderHis = this._decodeOrderHistory(this._orderHistory)) === null || _this$_decodeOrderHis === void 0 ? void 0 : _this$_decodeOrderHis.slice(1);
        var nonCateringDeliveryOrders = allPreviousOrders === null || allPreviousOrders === void 0 ? void 0 : allPreviousOrders.filter(function (order) {
          return order.orderType !== 2;
        });
        return nonCateringDeliveryOrders;
      }

      return null;
    }
  }, {
    key: "expiryTime",
    get: function get() {
      var _this$_appAttributes, _this$_appAttributes$;

      var expiryDays = ((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : (_this$_appAttributes$ = _this$_appAttributes.configs) === null || _this$_appAttributes$ === void 0 ? void 0 : _this$_appAttributes$.orderLookupExpiryDays) || 0;
      var numberOfDays = Math.abs(Number(expiryDays)); // return moment
      //   .duration(numberOfDays, "days")
      //   .humanize()
      //   .replace("a ", "1 ");

      var start = moment();
      var end = moment().add(numberOfDays, "days");
      var years = end.diff(start, "year");
      start.add(years, "years");
      var months = end.diff(start, "months");
      start.add(months, "months");
      var days = end.diff(start, "days");
      var yearsDisplay = years > 0 ? years + (years == 1 ? " year " : " years ") : "";
      var monthsDisplay = months > 0 ? months + (months == 1 ? " month " : " months ") : "";
      var daysDisplay = days > 0 ? days + (days == 1 ? " day" : " days") : "";
      return yearsDisplay + monthsDisplay + daysDisplay;
    }
  }]);

  return OrderHistoryModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_orderHistory", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_dayPartInfo", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_currentPickupTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_unavailableItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_currentOrderDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_menuDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_selectedOrderId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return "";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_recentOrdersFromLocalStorage", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "getMenuListAvailableItemIds", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "getMenuListAvailableItemIds"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentOrderDetails", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentOrderDetails"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "unavailableModifiers", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "unavailableModifiers"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderHistory", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderHistory"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "selectedOrderId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "selectedOrderId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "recentNonCateringDeliveryOrder", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "recentNonCateringDeliveryOrder"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousOrders", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousOrders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "previousNonCateringDeliveryOrders", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "previousNonCateringDeliveryOrders"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expiryTime", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "expiryTime"), _class.prototype)), _class);
export { OrderHistoryModel as default };